import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {Ng2TelInputModule} from 'ng2-tel-input';
import {SharedModule} from 'src/app/shared/shared.module';
import {DashboardRoutingModule} from './dashboard-routing.module';
import {DashboardComponent} from './dashboard.component';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {TranslateModule} from '@ngx-translate/core';

@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    DashboardRoutingModule,
    SharedModule,
    Ng2TelInputModule,
    NgbModule,
    TranslateModule
  ]
})
export class DashboardModule { }
